import { createSelector } from '@ngrx/store';

import { FinancialEntityBranch } from '@models/swagger';
import { State } from './reducer';
import { selectFinancialEntityBranchesState } from '../selectors';

export const getData = createSelector(selectFinancialEntityBranchesState, (state: State) => state.data);

export const getError = createSelector(selectFinancialEntityBranchesState, (state: State) => state.error);

export const getLoading = createSelector(selectFinancialEntityBranchesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: FinancialEntityBranch[]) => T) =>
  createSelector(selectFinancialEntityBranchesState, (state: State) => fn(state.data));
